<template>
<!--  <div class="back" @click="back">返回</div>-->
  <div class="main">
    <!-- 左边中文 -->
    <div style="width: 700px; height: 600px">
      <!--第一个盒子 标题、日期、发言人、关系  -->
      <div style="width: 620px; height: 120px; margin: 15px auto">
        <div style="
            display: inline-flex;
            justify-content: space-between;
            width: 280px;
            height: 80px;
            margin-left: 10px;
          "><em><span style="display:block" class="tip">标题:</span>{{ cn.topic }}</em></div>

        <div style="
            display: inline-flex;
            justify-content: space-between;
            width: 280px;
            height: 80px;
          "><em><span style="display:block" class="tip">日期：</span>{{ cn.dateTime }}</em></div>
<!--        <div style="-->
<!--            display: inline-flex;-->
<!--            justify-content: space-between;-->
<!--            width: 280px;-->
<!--            height: 40px;-->
<!--          "><em><span style="display:block" class="tip">发言人：</span>{{ cn.speaker }}</em></div>-->
<!--        <div style="-->
<!--            display: inline-flex;-->
<!--            justify-content: space-between;-->
<!--            width: 280px;-->
<!--            height: 40px;-->
<!--          "><em><span style="display:block" class="tip">与国家/地区的关系：</span>{{ cn.chRelation }}</em></div>-->
      </div>

      <!-- split -->
      <hr width="650" />

      <!--第二个盒子 四方块 来源、栏目-->
<!--      <div style="-->
<!--          display: flex;-->
<!--          justify-content: space-between;-->
<!--          width: 620px;-->
<!--          height: 80px;-->
<!--          margin: 15px auto;-->
<!--        ">-->
<!--        <div style="width: 300px">-->
<!--          <em><span style="display:block" class="tip">来源：</span>{{ cn.origin }}</em>-->
<!--        </div>-->
<!--        <div style="width: 300px">-->
<!--          <em><span style="display:block" class="tip">栏目：</span>{{ cn.webColumn }}</em>-->
<!--        </div>-->
<!--      </div>-->
      <!--第三个盒子 板块、主题 -->
<!--      <div style="-->
<!--          display: flex;-->
<!--          justify-content: space-between;-->
<!--          width: 620px;-->
<!--          height: 70px;-->
<!--          margin: 0 auto;-->
<!--        ">-->
<!--        <div style="width: 300px">-->
<!--          <em><span style="display:block" class="tip">板块：</span>{{ cn.section }}</em>-->
<!--        </div>-->
<!--        <div style="width: 300px">-->
<!--          <em><span style="display:block" class="tip">主题：</span>{{ cn.theme }}</em>-->
<!--        </div>-->
<!--      </div>-->
<!--      <hr width="650" />-->

      <!--第四个盒子 中文文本 -->
      <div style="width: 620px; height: 950px; margin: 15px auto; overflow: hidden">
        <div style="width: 580px; height: 250px">
          <span class="tip"><em>问题：</em></span>
          <span style="display:block"><em>{{ cn.question }}</em></span>
        </div>
        <hr width="550" />
        <div style="width: 580px; height: 700px">
          <span class="tip"><em>回答：</em></span>
          <span style="display:block"><em>{{ cn.answer }}</em></span>
        </div>
      </div>
    </div>

    <!-- 右边英文 -->
    <div style="width: 700px; height: 600px">
      <!--第一个盒子 标题、日期、发言人、关系  -->
      <div style="width: 620px; height: 120px; margin: 15px auto">
        <div style="
            display: inline-flex;
            justify-content: space-between;
            width: 280px;
            height: 80px;
            margin-left: 10px;
          "><em><span style="display:block" class="tip">topic：</span>{{ en.topic }}</em></div>
        <div style="
            display: inline-flex;
            justify-content: space-between;
            width: 280px;
            height: 80px;

          "><em><span style="display:block" class="tip">date：</span>{{ en.dateTime }}</em></div>
<!--        <div style="-->
<!--            display: inline-flex;-->
<!--            justify-content: space-between;-->
<!--            width: 280px;-->
<!--            height: 40px;-->
<!--          "><em><span style="display:block" class="tip">speaker：</span>{{ en.speaker }}</em></div>-->
<!--        <div style="-->
<!--            display: inline-flex;-->
<!--            justify-content: space-between;-->
<!--            width: 280px;-->
<!--            height: 40px;-->
<!--          "><em><span style="display:block" class="tip">relation：</span>{{ en.chRelation }}</em></div>-->
      </div>
      <hr width="700" />

      <!--第二个盒子 四方块 来源、栏目-->
<!--      <div style="-->
<!--          display: flex;-->
<!--          justify-content: space-between;-->
<!--          width: 620px;-->
<!--          height: 80px;-->
<!--          margin: 15px auto;-->
<!--        ">-->
<!--        <div style="width: 300px">-->
<!--          <em><span style="display:block" class="tip">origin：</span>{{ en.origin }}</em>-->
<!--        </div>-->
<!--        <div style="width: 300px">-->
<!--          <em><span style="display:block" class="tip">webColumn：</span>{{ en.webColumn }}</em>-->
<!--        </div>-->
<!--      </div>-->
      <!--第三个盒子 板块、主题 -->
<!--      <div style="-->
<!--          display: flex;-->
<!--          justify-content: space-between;-->
<!--          width: 620px;-->
<!--          height: 70px;-->
<!--          margin: 0 auto;-->
<!--        ">-->
<!--        <div style="width: 300px">-->
<!--          <em><span style="display:block" class="tip">section：</span>{{ en.section }}</em>-->
<!--        </div>-->
<!--        <div style="width: 300px">-->
<!--          <em><span style="display:block" class="tip">theme：</span>{{ en.theme }}</em>-->
<!--        </div>-->
<!--      </div>-->
      <hr width="700" />

      <!--第四个盒子 英文文本 -->
      <div style="width: 620px; height: 950px; margin: 15px auto; overflow: hidden">
        <div style="width: 580px; height: 250px">
          <span class="tip"><em>Question：</em></span>
          <span style="display:block"><em>{{ en.question }}</em></span>
        </div>
        <hr width="550" />
        <div style="width: 580px; height: 700px">
          <span class="tip"><em>Answer：</em></span>
          <span style="display:block"><em>{{ en.answer }}</em></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "@/util/axios"

export default {
  name: "sentence-data",
  data() {
    return {
      cn: {
        topic: '暂无数据',
        dateTime: '暂无数据',
        speaker: '暂无数据',
        chRelation: '暂无数据',
        origin: '暂无数据',
        webColumn: '暂无数据',
        section: '暂无数据',
        theme: '暂无数据',
        question: '暂无数据',
        answer: '暂无数据'
      },
      en: {
        topic: '暂无数据',
        dateTime: '暂无数据',
        speaker: '暂无数据',
        chRelation: '暂无数据',
        origin: '暂无数据',
        webColumn: '暂无数据',
        section: '暂无数据',
        theme: '暂无数据',
        question: '暂无数据',
        answer: '暂无数据'
      }
    }
  },
  created() {
    let cnCode = this.$route.query.cnCode
    let enCode = this.$route.query.enCode
    this.initData(cnCode, enCode)
  },
  methods: {
    back() {
      this.$router.go(-1);//返回上一层
    },
    async initData(cnCode, enCode) {
      let res = await axios.get('getSentenceTextPage?cnTextCode=' + cnCode + '&enTextCode=' + enCode)
      let cn = res.data.sentenceTextPageVO.sentenceTextDOMap.cn
      let en = res.data.sentenceTextPageVO.sentenceTextDOMap.en
      if (cn === null || en === null) {
        console.log('无数据')
        return
      }
      for (const [key, value] of Object.entries(cn)) {
        if (value === null) {
          console.log(key + '字段没有数据')
          return
        }
      }
      for (const [key, value] of Object.entries(en)) {
        if (value === null) {
          console.log(key + '字段没有数据')
          return
        }
      }
      this.cn = cn
      this.en = en
    }
  }
}
  ;
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-style: normal !important;
}

.back {
  width: 50px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  position: fixed;
  top: 10px;
  left: 5px;
  background-color: #000;
  color: #fff;
  font-size: 20px;
  cursor: pointer;
}

.main {
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  margin: 30px auto;
  width: 1400px;
  min-height: 1300px;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  z-index: 1;
  font-style: normal !important;
}

span {
  padding-left: 8px;
  font-weight: bold;
}
</style>